const subscriptionTypes = [
	"JOULE",
	"TICKET",
	"CAR_POOL",
	"TRAVEL_SUBSCRIPTION",
	"UNKNOWN",
] as const;
export type SubscriptionType = (typeof subscriptionTypes)[number];

export const parseSubscriptionType = (value: string): SubscriptionType => {
	if (subscriptionTypes.includes(value as SubscriptionType)) {
		return value as SubscriptionType;
	}

	return "UNKNOWN";
};
